
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignMeetingPoint as ObiSignMeetingPointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-meeting-point.js';
 
 
 

 
 export const ObiSignMeetingPoint = createComponent({
   react: React,
   tagName: 'obi-sign-meeting-point',
   elementClass: ObiSignMeetingPointElement,
   events: {
     
   }
  });
 
 